export default __webpack_public_path__ + "static/media/tarkan10.663ebfd3.jpg";